/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Button  } from '@mui/material';

const UserCreation = () => { 
    return (
        <>
            <Button variant="contained" color="primary" style={{ float: 'right' }}>Add user</Button>

        </>
    )

}

export default UserCreation;
